<template>
    <div id="app">
        <sw-header></sw-header>
        <main id="content" :style="content_style">
            <router-view></router-view>
            <cookie-law>
                <div slot="message">
                    Deze website gebruikt cookies om ervoor te zorgen dat deze website optimaal werkt.
                </div>
            </cookie-law>
        </main>
        <sw-footer ref="footer"></sw-footer>
    </div>
</template>

<script>
    import SwHeader from "@/components/Header.vue";
    import SwFooter from "@/components/Footer.vue";
    import CookieLaw from "vue-cookie-law";

    export default {
        metaInfo: {
            title: "",
            titleTemplate: chunk => {
                return chunk ? `${chunk} - SwBase Systems BV - Swbase.com` : 'SwBase Systems BV - Swbase.com';
            },
            meta: [
                {
                    'property': 'twitter:card',
                    'content': 'summary',
                    'vmid': 'twitter:card'
                },
                {
                    'property': 'og:url',
                    'content': url,
                    'vmid': 'og:url'
                },
                {
                    'property': 'og:title',
                    'content': '',
                    'template': chunk => chunk ? `${chunk} - SwBase Systems BV - Swbase.com` : 'SwBase Systems BV - Swbase.com',
                    'vmid': 'og:title'
                },
                {
                    'property': 'og:description',
                    'content': '',
                    'vmid': 'og:description'
                },
                {
                    'property': 'og:image',
                    'content': url + 'static/media/home_banner.jpg',
                    'vmid': 'og:image'
                },
                {
                    'property': 'og:locale',
                    'content': 'nl_NL',
                    'vmid': 'og:locale'
                },
            ]
        },
        components: {
            SwHeader,
            SwFooter,
            CookieLaw
        },
        data() {
            return {
                footer_height: 0,
            }
        },
        computed: {
            content_style() {
                const self = this;
                return {
                    "padding-bottom": self.footer_height + "px",
                }
            }
        },
        methods: {
            set_content_padding() {
                const self = this;

                const footer_ref = self.$refs.footer;
                self.footer_height = footer_ref.$el.getBoundingClientRect().height;
            }
        },
        mounted() {
            const self = this;
            self.set_content_padding();
        }
    }
</script>

<style scoped="scoped">
    #content {
        position: relative;
    }

    #app {
        min-height: 100%;
        width: 100%;
        position: relative;

        display: flex;
        flex-direction: column;
    }
</style>